import { render, staticRenderFns } from "./notice.pug?vue&type=template&id=064a1ebd&lang=pug&"
import script from "./notice.ts?vue&type=script&lang=ts&"
export * from "./notice.ts?vue&type=script&lang=ts&"
import style0 from "./notice.styl?vue&type=style&index=0&lang=stylus&%2C=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports